export const API_URL = process.env.REACT_APP_API_URI ?? 'https://notefy.fly.dev'
export const API_KEY = process.env.REACT_APP_API_KEY;
export const EMAIL_KEY = process.env.REACT_APP_EMAIL_KEY;